import axios from "@/libs/axios";

export async function countries(query = null) {
  try {
    const { data: { data } } = await axios.get('/api/v1/utils/address/countries', { params: query });
    return { data };
  } catch (error) {
    return { error: null }
  }
}
